// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2DItN","label":"CategoryService_label__Nt55b","location":"CategoryService_location__169wQ"};